import React, { useState } from 'react'
import { Dialog, IconButton, DialogTitle, DialogContent, Grid, TextField, Button, FormControlLabel, Checkbox } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import { toast } from 'react-toastify'

import './style.css'
import { Model } from '../../../models/model'

export const DialogNewUnidad = ({ open, setOpen, initialData, getAllUnit }) => {

    const [form, setForm] = useState({
        id: initialData.id,
        nombre: initialData.nombre,
        estado: initialData.estado,
        por_defecto: initialData.por_defecto
    })

    const handleSave = async () => {

        if (form.nombre === '') {
            toast.warn("Ingrese nombre")
            return false
        }

        if (form.id > 0) {

            const resultUpdate = await Model.update({
                url: `unidad/${form.id}`,
                dataForm: form
            })

            console.log('--resultUpdate--', resultUpdate)

        } else {

            const resultId = await Model.save({
                url: 'unidad',
                dataForm: form
            })

            console.log('--resultId save--', resultId)

            setForm({
                ...form,
                id: resultId
            })

        }

        await getAllUnit()

    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        })
    }

    const handleChecked = ({ target }) => {
        setForm({
            ...form,
            estado: target.checked
        })
    }

    return (
        <Dialog
            className='dialogoContacs'
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="simple-dialog-title"
        >
            <DialogTitle id="scroll-dialog-title">
                {form.id > 0 ?
                    <div>Detalle Unidad de negocio <span className="text-uppercase">( {form.nombre} )</span></div>
                    :
                    `Nueva unidad de negocio ${form.nombre !== '' ? `( ${form.nombre} )` : ''}`
                }
                <IconButton
                    aria-label="close"
                    style={{ padding: '0', float: 'right' }}
                    onClick={() => setOpen(false)}
                >
                    <CloseIcon style={{ color: '#78667E' }} />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <Grid container spacing='20' columnSpacing='16' alignItems='center' direction='row'>
                    <Grid item xs={12}>
                        <FormControlLabel
                            control={<Checkbox style={{ color: '#8E24AA' }} checked={form.estado} />}
                            label="Habilitado"
                            onChange={handleChecked}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            label="Nombre Unidad (*)"
                            name="nombre"
                            id="outlined-size-small"
                            value={form.nombre || ''}
                            size="small"
                            fullWidth
                            placeholder='Ingrese nombre unidad'
                            onChange={handleChange}
                        />
                    </Grid>
                    <Grid item xs={12} className="text-end">
                        <Button
                            id="id-button-save-ppto"
                            className='p-btn-primary'
                            variant="contained"
                            size='medium'
                            onClick={handleSave}
                            type='button'
                        >
                            {''}Guardar
                        </Button>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}